import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { NotificationDto } from "./notifications-dto";

export class NotificationResponse extends GlobalResponseObject{
    data?: NotificationDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: NotificationDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}